import React, { useEffect } from "react";
import HomeHeroSection from "./HomeHeroSection";
import AboutUs from "./AboutUs";
import Experience from "./Experience";
import Service from "./Service";
import Consaltancy from "./Consaltancy";
import Questions from "./Questions";
import Blog from "./Blog";
import NewsLetter from "./NewsLetter";

const structureSchema = {
  "@context": "https://schema.org/",
  "@type": "WebSite",
  name: "Johnbostjancic",
  url: "https://johnbostjancic.co",
};

const HomePage = () => {
  useEffect(() => {
    let metaTag = document.querySelector("meta[name='description']");
    document.title = "John Bostjancic CFO - Sonendo, Inc. | Finance Expert";
    const scriptTag = document.createElement("script");

    if (metaTag) {
      metaTag.setAttribute(
        "content",
        "I’m John Bostjancic, CFO at Sonendo, Inc., specializing in financial leadership, operational efficiency, and strategic planning."
      );
    } else {
      metaTag = document.createElement("meta");
      (metaTag as HTMLMetaElement).name = "description";
      (metaTag as HTMLMetaElement).setAttribute(
        "content",
        "I’m John Bostjancic, CFO at Sonendo, Inc., specializing in financial leadership, operational efficiency, and strategic planning."
      );
      document.head.appendChild(metaTag);
    }

    let linkTag = document.querySelector("link[rel='canonical']");
    if (linkTag) {
      linkTag.setAttribute("href", "https://johnbostjancic.co/");
    } else {
      linkTag = document.createElement("link");
      (linkTag as HTMLLinkElement).rel = "canonical";
      (linkTag as HTMLLinkElement).href = "https://johnbostjancic.co/";
    }

    if (!document.head.contains(linkTag)) {
      document.head.appendChild(linkTag);
    }

    //keyWords
    let keyWordTag = document.querySelector("meta[name='keywords']");
    if (!keyWordTag) {
      keyWordTag = document.createElement("meta");
      (keyWordTag as HTMLMetaElement).name = "keywords";
      document.head.appendChild(keyWordTag);
    }
    keyWordTag.setAttribute("content", "John Bostjancic");

    // Schema
    scriptTag.setAttribute("type", "application/ld+json");
    scriptTag.textContent = JSON.stringify(structureSchema);

    // Remove existing schema if present
    const existingSchema = document.querySelector(
      "script[type='application/ld+json']"
    );
    if (existingSchema) {
      document.head.removeChild(existingSchema);
    }

    document.head.appendChild(scriptTag);
  }, []);

  return (
    <>
      <div className="overflow-hidden sm:overflow-visible">
        <HomeHeroSection />
        <AboutUs />
        <Experience />
        <Service />
        <Consaltancy />
        <Questions />
        {/* <Testamonial /> */}
        <Blog />
        <NewsLetter />
      </div>
    </>
  );
};

export default HomePage;
